export default __webpack_public_path__ + "static/media/icon_refresh.2e8da48d.svg";